import QAResumeRepository from "../../repositories/qa_resume.repository";
import QAResponseQuestionEntity from "../../entities/qa_response_question.entity";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";

interface Props {
    qaResumeRepository: QAResumeRepository;
}

export default class UpdateResponseQuestionUseCase {
    private _qaResumeRepository: QAResumeRepository;

    constructor({ qaResumeRepository }: Props) {
        this._qaResumeRepository = qaResumeRepository;
    }

    public call = async (response: QAResponseQuestionEntity, jobId: string): Promise<Either<ErrorEntity, QAResponseQuestionEntity>> => {
        return this._qaResumeRepository.updateResponseQuestion(response, jobId);
    };
}

export const UpdateResponseQuestionUseCaseName = "UpdateResponseQuestionUseCase";